import _ from "lodash";
import * as classroomApi from "./classroomApi";
import iconWindowsDevice from "../../assets/IconWindowsDevice.svg?url";

export interface SignaturesResponse {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	signatures: SignatureData[];
	appControls: AppControlData[];
}

export interface SignatureData {
	category: null | string;
	dependencies: string[];
	description: string;
	enabled: boolean;
	favicon_url: null | string;
	focus: boolean;
	hidden: boolean;
	id: string;
	is_category: boolean;
	is_high_level_signature: boolean;
	is_low_level_signature: boolean;
	is_sub_category: boolean;
	name: string;
	noise: boolean;
	reporting: boolean;
	tags: string[];
	url: null | string;
}

export interface AppControlData {
	id: string;
	name: string;
	favicon: string;
	platforms: Array<"windows">; // element will be a union type when more platforms are added
}

export async function getSignatures(): Promise<SignaturesResponse> {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const res: SignaturesResponse = await classroomApi.Get2("v1/signatures");

	for (const appControl of res.appControls) {
		if (_.isEmpty(appControl.favicon)) {
			appControl.favicon = iconWindowsDevice;
		}
	}

	return res;
}
